export default {
  406: {
    'There are no documents assigned to the number': 'Aktualnie brak dokumentów przypisanych do wprowadzonego numeru.',
    'Download file error': 'Błąd pobierania pliku',
    'SQL syntax error': 'Błąd składni SQL',
    'Login has been blocked': 'Możliwość logowania została zablokowana',
    'Wrong SMS code': 'Nieprawidłowy kod sms',
  },
  403: {
    forbidden: 'Nieprawidłowy numer telefonu lub hasło.',
  },
};
